import React from 'react';
import InvitationEvaluationTable from './InvitationEvaluationTable';

const HydrocarbonCondensatTable = ({ refreshTrigger }) => (
  <InvitationEvaluationTable
    procurementTypeHeader='2'
    refreshTrigger={refreshTrigger}
  />
);

export default React.memo(HydrocarbonCondensatTable);
